<template>
  <div class="ui form" style="width: 100%;height: 400px">
    <div class="field" style="height: calc(100% - 20px)">
      <label v-if="!options.hideLabel">{{label}}</label>
      <l-map ref="map" :zoom="zoom" :center="mapCenter" :options="options">
        <l-tile-layer :url="url" @click="()=>{}"></l-tile-layer>
      </l-map>
    </div>
  </div>
</template>

<script>
  import singleControlMixin from './singleControlMixin'

  import L from 'leaflet';

  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
  });

  import "leaflet/dist/leaflet.css";

  import {LMap, LTileLayer} from 'vue2-leaflet'

  import 'leaflet.pm';
  import 'leaflet.pm/dist/leaflet.pm.css';

  import 'leaflet-graphicscale'
  import 'leaflet-graphicscale/dist/Leaflet.GraphicScale.min.css'

  import 'leaflet-easybutton'
  import 'leaflet-easybutton/src/easy-button.css'

  import 'leaflet-mouse-position'
  import 'leaflet-mouse-position/src/L.Control.MousePosition.css'

  export default {
    name: "geojson-control",
    mixins: [singleControlMixin],

    props: {
      mode: {
        type: String,
        default: "AreaObject"//"PointObject"
      },
      zoom: {
        type: Number,
        default: 4
      },
      center: {
        type: Object,
        default: () => {
          return {
            lat: 53.2000700,
            lng: 50.1500000
          }
        }
      },
      url: {
        type: String,
        default: navigator.onLine ? '//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' : 'static/leaflettiles/{z}/{y}/{x}.jpg'
      },
      options: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },

    data() {
      return {
        layer: null,
        map: null,
        points: null,
        point: null
      }
    },

    computed: {
      mapCenter() {
        return L.latLng(this.center.lat, this.center.lng)
      }
    },

    mounted() {
      if (this.mode === 'AreaObject')
        this.points = this.getValue ? JSON.parse(this.getValue.trim()).features[0].geometry.coordinates[0] : null;
      else this.point = this.getValue ? JSON.parse(this.getValue.trim()).features[0].geometry.coordinates : null;

      this.map = this.$refs.map.mapObject;
    },

    methods: {
      setFreeDrawControls() {
        this.map.pm.addControls({
          position: 'topright',
          drawMarker: false,
          drawPolyline: false,
          drawRectangle: this.mode === "AreaObject" && !this.layer,
          drawPolygon: this.mode === "AreaObject" && !this.layer,
          drawCircle: false,
          cutPolygon: false,
          editMode: false,
          removalMode: false
        });
      },

      addFreeDraw() {
        if (this.mode === "AreaObject")
          this.setFreeDrawControls();
        else if (!this.point) this.enableAddMarkerMode();

        if (this.points || this.point) {
          this.layer = L.geoJson(this.points !== null ? this.createPolygonGeoJson(this.points) : this.createPointGeoJson(this.point))
            .addTo(this.map).pm._layers[0];

          if (this.points !== null)
            this.map.fitBounds(this.layer.getBounds());
          else
            this.map.setView(this.point.reverse(), 15);
        }

        this.map.on('pm:create', (e) => {
          this.layer = e.layer;

          e.layer.on('pm:edit', () => {
            this.updatePoints(this.layer)
          });
        });

        L.control.mousePosition().addTo(this.map);
        L.control.graphicScale({position: 'bottomright',fill:'fill'}).addTo(this.map);
      },
      createPolygonGeoJson(points) {
        if (points) {
          if (points[0][0] != points[points.length - 1][0] || points[0][1] != points[points.length - 1][1])
            points.push(points[0]);


          return {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: [
                    JSON.parse(JSON.stringify(points))
                  ]
                },
                properties: {}
              }
            ]
          };
        } else {
          return null;
        }
      },

      createPointGeoJson(point) {
        return point ? {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: JSON.parse(JSON.stringify(point))
              },
              properties: {}
            }
          ]
        } : null;
      },

      updatePoints(layer) {
        function n(number) {
          return Number((number).toFixed(5));
        }

        if (this.mode === "AreaObject")
          this.points = layer ? layer.pm._layer._latlngs[0].map(e => [n(e.lng), n(e.lat)]) : null;
        else this.point = layer ? [n(layer._latlng.lng), n(layer._latlng.lat)] : null;
      },

      addRemoveLayerButton() {
        L.easyButton({
          position: 'topright',
          states: [{
            stateName: 'remove-layer',
            onClick: (button, map) => {
              map.removeLayer(this.layer);
              this.layer = null;
              map.removeControl(button);
            },
            icon: '<div style="margin-top: 1px"> <img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDkwMC41IDkwMC41IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA5MDAuNSA5MDAuNTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik0xNzYuNDE1LDg4MC41YzAsMTEuMDQ2LDguOTU0LDIwLDIwLDIwaDUwNy42N2MxMS4wNDYsMCwyMC04Ljk1NCwyMC0yMFYyMzIuNDg3aC01NDcuNjdWODgwLjVMMTc2LjQxNSw4ODAuNXogICAgTTU2Mi43NSwzNDIuNzY2aDc1djQzNi4wMjloLTc1VjM0Mi43NjZ6IE00MTIuNzUsMzQyLjc2Nmg3NXY0MzYuMDI5aC03NVYzNDIuNzY2eiBNMjYyLjc1LDM0Mi43NjZoNzV2NDM2LjAyOWgtNzVWMzQyLjc2NnoiIGZpbGw9IiMwMDAwMDAiLz4KCTxwYXRoIGQ9Ik02MTguODI1LDkxLjkxMVYyMGMwLTExLjA0Ni04Ljk1NC0yMC0yMC0yMGgtMjk3LjE1Yy0xMS4wNDYsMC0yMCw4Ljk1NC0yMCwyMHY3MS45MTF2MTIuNXYxMi41SDE0MS44NzQgICBjLTExLjA0NiwwLTIwLDguOTU0LTIwLDIwdjUwLjU3NmMwLDExLjA0NSw4Ljk1NCwyMCwyMCwyMGgzNC41NDFoNTQ3LjY3aDM0LjU0MWMxMS4wNDYsMCwyMC04Ljk1NSwyMC0yMHYtNTAuNTc2ICAgYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwSDYxOC44MjV2LTEyLjVWOTEuOTExeiBNNTQzLjgyNSwxMTIuNzk5aC0xODcuMTV2LTguMzg5di0xMi41Vjc1aDE4Ny4xNXYxNi45MTF2MTIuNVYxMTIuNzk5eiIgZmlsbD0iIzAwMDAwMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=" /> </div>'
          }]
        }).addTo(this.map);
      },
      enableEditMode() {
        this.layer.pm.enable({
          draggable: false,
          snappable: true,
          snapDistance: 30,
          allowSelfIntersection: true,
          preventMarkerRemoval: false,
          preventVertexEdit: false,
        });
      },

      enableAddMarkerMode() {
        this.map.pm.enableDraw('Marker', {snappable: false});
      },

      disableAddMarkerMode() {
        this.map.pm.disableDraw('Marker');
      }
    },
    components: {LMap, LTileLayer},
    watch: {
      map(newVal) {
        if (!newVal) return;
        this.addFreeDraw()
      },
      layer(newVal) {
        if (newVal) {
          this.addRemoveLayerButton();
          this.enableEditMode();
        }
        if (this.mode === "AreaObject")
          this.setFreeDrawControls();
        else if (!newVal) this.enableAddMarkerMode(); else this.disableAddMarkerMode();
        this.updatePoints(newVal);
      },
      points(newVal) {
        this.setValue(newVal ? JSON.stringify(this.createPolygonGeoJson(newVal)) : null)
      },
      point(newVal) {
        this.setValue(newVal ? JSON.stringify(this.createPointGeoJson(newVal)) : null)
      }
    }
  }
</script>

<style>
  .easy-button-button {
    padding-left: 0;
    padding-right: 0;
  }

  .leaflet-control-attribution {
    display: none !important;
  }

  .leaflet-control-graphicscale {
    margin: 0 !important;
    padding-right: 10px;
    background-color: rgba(255, 255, 255, 0.7);
  }
</style>
